import { lazy, Suspense } from "react";
import { ParticipantPage } from "./pages/ParticipantPage";
import { QrPage } from "./pages/QrPage";

const AdminPage = lazy(async () => {
  const module = await import("./pages/AdminPage");
  return { default: module.AdminPage };
});

export default function App() {
  const path = window.location.pathname.replace(/\/+$/u, "") || "/";
  if (path === "/admin" || path.startsWith("/admin/")) {
    return (
      <Suspense fallback={<main className="center-screen">正在加载组织者控制台…</main>}>
        <AdminPage />
      </Suspense>
    );
  }
  if (path.startsWith("/q/")) return <QrPage code={decodeURIComponent(path.slice(3))} />;
  if (path.startsWith("/event/")) {
    return <ParticipantPage slug={decodeURIComponent(path.slice(7))} />;
  }
  if (/^\/[^/]+$/u.test(path)) {
    return <ParticipantPage slug={decodeURIComponent(path.slice(1))} />;
  }
  return <ParticipantPage />;
}
